import React, { useId, useState } from "react";
import { useReceivingPopupUi } from "./receivingPopupMessages";
import "./OcrAiReviewPanel.css";

export default function OcrAiReviewComments({ comments = [], summary = "", notice = "" }) {
  const { t } = useReceivingPopupUi();
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  const entries = [notice, summary, ...comments].filter(Boolean);
  if (!entries.length) return null;
  return <section className="ocr-ai-comments">
    <button type="button" className="ocrp-btn ocr-ai-comments-toggle" aria-expanded={expanded} aria-controls={id}
      onClick={() => setExpanded((value) => !value)}>
      <span aria-hidden="true">{expanded ? "▾" : "▸"}</span>
      {t("AI comments ({count})", { count: entries.length })}
    </button>
    <div id={id} hidden={!expanded}>
      {expanded && <ul className="ocr-ai-warnings">{entries.map((entry, index) => <li key={index}>{entry}</li>)}</ul>}
    </div>
  </section>;
}
